import { render, staticRenderFns } from "./feedback_add.vue?vue&type=template&id=5a60f65a&scoped=true&"
import script from "./feedback_add.vue?vue&type=script&lang=ts&"
export * from "./feedback_add.vue?vue&type=script&lang=ts&"
import style0 from "./feedback_add.vue?vue&type=style&index=0&id=5a60f65a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a60f65a",
  null
  
)

export default component.exports